// luxury-storytelling.js
document.addEventListener('DOMContentLoaded', () => {
  const stories = document.querySelectorAll('.luxury-story');

  if (!stories.length) return;

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  stories.forEach(story => {
    observer.observe(story);
  });
});
